import { all, takeLatest, call, put } from 'redux-saga/effects';

import { ERROR } from '@coconut/constants/apiStatus';
import { ALERT_SYSTEMINFO_THEME } from '@coconut/constants/alertBannerThemes';
import { showAlertBanner } from '@coconut/services/redux/alertBanner';

import { updateAasmstateAfterRateSuccess } from '../../scenes/Home/services/redux/completedQuestions';
import { types, rateQuestionSuccess, rateQuestionFailed } from '../redux/rate';
import * as apis from '../apis/rate';

function* rateQuestionFlow(action) {
  const { userId, questionId, score, comment, messageId } = action.payload;

  try {
    const response = yield call(apis.postRating, {
      userId,
      questionId,
      score,
      comment,
      messageId,
    });

    if (response.status === ERROR) {
      throw new Error(response.error_code);
    }

    yield put(rateQuestionSuccess(response.data));
    yield put(updateAasmstateAfterRateSuccess(response.data));
    yield put(
      showAlertBanner({
        theme: ALERT_SYSTEMINFO_THEME,
        message: 'qaOnWeb.systemHint.sessionEnd',
      })
    );
  } catch (err) {
    yield put(rateQuestionFailed(err.message));
  }
}

export default function* () {
  yield all([takeLatest(types.RATE_QUESTION, rateQuestionFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/rate.js